export default "__VITE_ASSET__DXfThllc__"